import React from "react";
import Layout from "../layout/Layout";
import { Button, Card, Col, Flex, Row, Typography } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

const QAQCJobReportMenu = ({ history }) => {
	const showFiledReports = () => {
		history.push("/qc/job/fieldreports");
	};

	const showQCLaboratory = () => {
		history.push("/qc/job/cylindertesting");
	};

	const showQCUploadExternal = () => {
		history.push("/qc/job/uploadexternal");
	};

	const CustomDashboard = () => {
		return (
			<div>
				<Row gutter={16}>
					<Col span={8}>
						<Card
							bordered
							style={{ backgroundColor: "#16207cff", cursor: "pointer" }}
							onClick={showFiledReports}
						>
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									Field Reports
								</Title>
								<Text style={{ color: "white" }}>Pour Performance</Text>
							</Flex>
						</Card>
					</Col>
					<Col span={8}>
						<Card
							bordered
							style={{ backgroundColor: "#3533b6ff", cursor: "pointer" }}
							onClick={showQCLaboratory}
						>
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									Laboratory Test Reports
								</Title>
								<Text style={{ color: "white" }}>Compressive Testing</Text>
							</Flex>
						</Card>
					</Col>
					<Col span={8}>
						<Card
							bordered
							style={{
								backgroundColor: "rgb(51, 117, 182)",
								cursor: "pointer",
							}}
							onClick={showQCUploadExternal}
						>
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									Customer Test Reports
								</Title>
								<Text style={{ color: "white" }}>Compressive Test Report</Text>
							</Flex>
						</Card>
					</Col>
				</Row>
			</div>
		);
	};

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout title="QA/QC Job Report" description="Menu">
			<Flex vertical gap={16}>
				<Button
					type="primary"
					size="large"
					icon={<RollbackOutlined />}
					onClick={goBack}
				/>
				<CustomDashboard />
			</Flex>
		</Layout>
	);
};

export default QAQCJobReportMenu;
